import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "../../common/models/PermissionMap";
import { Customer, customerFactory } from "../../common/models/Customer";
import { Contract, contractFactory } from "./Contract";
import { Site, siteFactory } from "./Site";
import { DeploymentStatus } from "../../common/models/DeploymentStatus";

export type ServerType =
  | "shared_hosting"
  | "virtual_server"
  | "windhosting_server";
export class Server {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
    public readonly notes: string | null,
    public readonly hostname: string | null,
    public readonly deploymentStatus: DeploymentStatus,
    public readonly serverType: ServerType,
    public readonly customer: Customer | null,
    public readonly managedHosting: boolean,
    public readonly managedServer: boolean,
    public readonly defaultNginxConfig: string,
    public readonly contracts: Contract[],
    public readonly ipAddresses: string[],
    public readonly sites: Site[],
    public readonly isShared: boolean,
    public readonly permissions: PermissionMap | null,
  ) {}
}

class ServerFactory extends ModelFactory<Server> {
  protected fromJson(json: any): Server {
    return new Server(
      json["id"],
      json["display_name"],
      json["notes"],
      json["hostname"],
      json["deployment_status"],
      json["type"] === "shared_hosting_server"
        ? "shared_hosting"
        : json["type"],
      json["customer"]
        ? customerFactory.fromItemResponse(json["customer"])
        : null,
      json["with_managed_webhosting"] ?? false,
      json["with_managed_server"] ?? false,
      json["default_nginx_configuration"] ?? "",
      json["contracts"]
        ? contractFactory.fromItemsResponse(json["contracts"])
        : [],
      json["ip_addresses"] ? json["ip_addresses"] : [],
      json["sites"] ? siteFactory.fromItemsResponse(json["sites"]) : [],
      json["is_shared"],
      parseItemPermissions(json["permissions"]),
    );
  }
}
export const serverFactory = new ServerFactory();
